import { isUnfiledPile } from '@/modules/projects/components/Workbench/fromProject'
import {
  DROPPING_ON,
  type MapActions,
  TARGET_UNDER_POINTER,
} from '@/modules/projects/components/Workbench/mapView'
import {
  filesOf,
  pagesReadOut,
  sentenceCase,
} from '@/modules/projects/components/Workbench/moves'
import { StatementButton } from '@/modules/projects/components/Workbench/StatementButton'
import type {
  DocumentPage,
  StatementView,
} from '@/modules/projects/components/Workbench/types'
import { cn, truncate } from '@/utils'

// Every pile in the tray says the same thing, so the tray says it once and each chip is just
// how many pages and which file. The whole file name is in the chip's title.
const FILE_NAME_LIMIT = 28

const pileLabel = (pages: DocumentPage[]) =>
  `${pages.length} ${pages.length === 1 ? 'page' : 'pages'} · ${truncate(pages[0]?.source.fileName ?? '', FILE_NAME_LIMIT)}`

export const Unplaced = ({
  views,
  pagesOf,
  choosing,
  openStatementId,
  actions,
}: {
  views: StatementView[]
  pagesOf: (pages: number[]) => DocumentPage[]
  choosing: boolean
  openStatementId: string | null
  actions: MapActions
}) => (
  <div className="flex flex-wrap items-center gap-1.5 border-b px-4 py-2">
    <span className="whitespace-nowrap text-xs text-ink-subtle">
      Not on the map yet:
    </span>
    {views.map((view) => {
      const pages = pagesOf(view.pages)
      return (
        <StatementButton
          key={view.statement.id}
          view={view}
          choosing={choosing}
          deletable={!isUnfiledPile(view.statement.id)}
          title={filesOf(pages).join(', ')}
          actions={actions}
          className={cn(
            'cursor-pointer whitespace-nowrap rounded-md px-2 py-0.5 text-[11px] font-medium transition-colors',
            'bg-neutral-200 text-foreground',
            choosing ? TARGET_UNDER_POINTER : 'hover:bg-neutral-300',
            openStatementId === view.statement.id &&
              'bg-neutral-900 text-white hover:bg-neutral-900',
            DROPPING_ON,
          )}
        >
          {isUnfiledPile(view.statement.id)
            ? pileLabel(pages)
            : sentenceCase(pagesReadOut(pages))}
        </StatementButton>
      )
    })}
  </div>
)
